<template>
  <main-layout selectedMenu="explore">
    <div class="contentstart">
      <div class="absolutetopbox">
        <div class="banner">
          <swiper
            :options="bannerSlideList.length ==1 ? swiperOptionsNo : swiperOptions"
            ref="mySwiper"
            class="wrapperswiper"
            v-if="bannerSlideList.length>0"
          >
            <!-- slides -->
            <swiper-slide v-for="(item,index) in bannerSlideList" :key="index">
              <div class="bannercenter" style="width:100%;height: 330px;background-color: #ccc;">
                <div
                  style="position: relative;z-index: 5; width:1160px;margin:0 auto; height: 330px;text-align: center"
                >
                  <img
                    style="width: 100%;height: 330px;cursor: pointer"
                    :src="item.bannerImage | imageUrl('',1160,330)"
                    @click="goBannerUrl(item.url)"
                  />
                </div>
                <div class="fixedsbox" :style="item.bannerImage | bgImageUrl('',1160,330)"></div>
              </div>
            </swiper-slide>
            <div
              class="swiper-pagination"
              v-for="(item,index) in bannerSlideList"
              :key="index"
              slot="pagination"
            ></div>
          </swiper>
          <div v-else-if="bannerSlideList.length == 0" class="thumba">
            <div class="bg" :style="detail.banner | bgImageUrl"></div>
            <img :src="detail.banner | imageUrl('',2320,660)" />
          </div>
        </div>
      </div>
      <div class="touchdesigner">
        <div class="touchleft">
          <div class="top">
            <img
              :style="detail.thumb | bgImageUrl('', 300, 300)"
              style="background-position: center center"
            />
            <div class="designlabel">
              <p>
                <b>{{detail.title}}</b>
                <span v-for="item in detail.professionList" :key="item.id">#{{item.title}}</span>
              </p>
              <p class="directitemList">
                <b>主持团：</b>
                <span>{{directitemList&&directitemList.map(item=>item.nickName).join('、')}}</span>
              </p>
            </div>
          </div>
          <div class="descreption">
            <p v-html="detail.introduction" :class="{checking:isChecking}"></p>
            <span class="showdown" @click="introduc" v-if="checkall">{{$t('global.更多')}}</span>
            <span class="showup" v-if="isShowUpShow" @click="showupCk">{{$t('global.收起')}}</span>
          </div>
        </div>
        <div class="touchright">
          <button @click="shareCkeck()" class="shareds">
            <span>{{$t('global.分享')}}</span>
          </button>
          <button
            class="addsheq"
            :class="{followed:state===$t('global.已关注')}"
            @click="Join()"
          >{{state}}</button>
          <p>
            <span>{{$t('global.成员')}}</span>
            <b>{{detail.memberCount}}</b>
            <span>{{$t('global.视频')}}</span>
            <b>{{detail.videoCount}}</b>
            <span>{{$t('global.活动')}}</span>
            <b>{{detail.activityCount}}</b>
          </p>
          <div class="parentShare">
            <share
              :config="config"
              :class="{animated:isWinsup,bounceInUp:istp140,closeshare:iscloseShare}"
              id="sharefrienf"
            ></share>
          </div>
        </div>
      </div>

      <div class="clearfix"></div>
      <div class="designercontet">
        <div class="navhead">
          <ul>
            <li :class="{active:activeIndex == 0}" @click="changeIndex(0)">{{$t('global.全部')}}</li>
            <li :class="{active:activeIndex == 1}" @click="changeIndex(1)">{{$t('global.视频')}}</li>
            <li :class="{active:activeIndex == 2}" @click="changeIndex(2)">{{$t('global.活动')}}</li>
            <li :class="{active:activeIndex == 4}" @click="changeIndex(4)">{{$t('global.文章')}}</li>
            <li :class="{active:activeIndex == 5}" @click="changeIndex(5)">{{$t('global.创作者')}}</li>
            <li :class="{active:activeIndex == 3}" @click="changeIndex(3)">{{$t('global.成员')}}</li>
          </ul>
          <div class="member" v-if="detail.memberCount">
            <p>
              {{$t('global.共x位成员',{count:detail.memberCount})}}
              <span
                v-for="item in memberList"
                :key="item.userId"
              >
                <img :src="item.avatar | imageUrl('/static/profile_img_default.png',48,48)" alt />
              </span>
            </p>
          </div>
        </div>
        <div class="contentleft" v-if="activeIndex == 0">
          <div class="communActivity videobox">
            <strong>{{$t('global.视频')}}</strong>
            <div @click="showVideoSortList">
              <span>
                <img :src="sortVideoSelected.icon" />
                {{sortVideoSelected.title}}
              </span>
              <ul @click.stop="sortVideo" v-if="showVideoSort">
                <li v-for="item in sortList" :key="item.id" :data-sort="item.id">
                  <img :src="item.icon" />
                  {{item.title}}
                </li>
              </ul>
            </div>
          </div>
          <div class="videstart" v-if="designvideolist.length > 0">
            <ul>
              <li v-for="item in designvideolist" :Key="item.videoId">
                <router-link target="_blank" :to="'/video/detail?id='+item.videoId">
                  <img class="videothump" :src="item.thumb | imageUrl('', 700, 394)" />
                  <p
                    style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;line-clamp: 2;"
                  >{{item.title}}</p>
                  <div class="userheadinfor">
                    <div class="userleft" @click.stop.prevent="goToUser(item.userId)">
                      <img :src="item.avatar | imageUrl('/static/profile_img_default.png',52,52)" />
                      <span>{{item.nickName}}</span>
                    </div>
                    <div class="userright">
                      <img src="/static/home/images/eyes.png" />
                      <span>{{item.viewCount}}</span>
                    </div>
                  </div>
                </router-link>
                <span class="videotime">{{item.duration | secondToDate}}</span>
              </li>
            </ul>
          </div>
          <content-empty
            style="padding-bottom:30px"
            v-else-if="designvideolist.length == 0"
            :content="$t('global.没有相关的视频')"
          ></content-empty>
        </div>

        <!--$t('global.讨论区域')-->
        <discussArea
          v-if="activeIndex == 4"
          :topicId="topicId"
          :topic-name="detail.title"
          :active-index="activeIndex"
        ></discussArea>

        <!--$t('global.右侧区域')-->
        <subject-detail-right
          :active-index="activeIndex"
          :topic-id="topicId"
          :topic-name="detail.title"
          :is-more="true"
          :is-create="isCreate"
          @show-publishbtn="publishbtn"
          @change-index="changeIndex"
          @follow="Follow"
        ></subject-detail-right>

        <div class="checkvideomodel" v-if="activeIndex == 1">
          <div class="middle">
            <div class="orderby">
              <label v-bind:class="{active:selectedOrder==0}" v-on:click="selectedOrder=0">
                <span class="orderby-icon-time" :class="{'active-time':selectedOrder==0}"></span>
                {{$t('global.默认排序')}}
              </label>
              <label v-bind:class="{active:selectedOrder==2}" v-on:click="selectedOrder=2">
                <span class="orderby-icon-visit" :class="{'active-visit':selectedOrder==2}"></span>
                {{$t('global.按浏览量')}}
              </label>
              <label v-bind:class="{active:selectedOrder==3}" v-on:click="selectedOrder=3">
                <span class="orderby-icon-zan" :class="{'active-zan':selectedOrder==3}"></span>
                {{$t('global.按点赞数')}}
              </label>
              <label v-bind:class="{active:selectedOrder==4}" v-on:click="selectedOrder=4">
                <span class="orderby-icon-comment" :class="{'active-comment':selectedOrder==4}"></span>
                {{$t('global.按评论数')}}
              </label>
              <strong>
                {{$t('global.共')}}
                <b>{{detail.videoCount}}</b>
                {{$t('global.个视频')}}
              </strong>
            </div>

            <div class="unityvideo" v-if="listLength > 0">
              <router-link
                tag="div"
                class="subjectpropusitem"
                v-for="item in list"
                :to="'/video/detail?id='+item.videoId"
                :key="item.videoId"
              >
                <router-link :to="'/video/detail?id='+item.videoId">
                  <img class="subject-img" :src="item.thumb | imageUrl('',275,155)" />
                  <span class="videotime">{{item.duration | secondToDate}}</span>
                </router-link>
                <a class="saytitle">{{item.title}}</a>
                <div>
                  <a class="userlistpic">
                    <img
                      class="subject-author-avatar"
                      @click.stop="goToUser(item.userId)"
                      :src="item.avatar | imageUrl('/static/profile_img_default.png',52,52)"
                    />
                  </a>
                  <a @click.stop="goToUser(item.userId)">{{item.nickName}}</a>
                  <span class="openeye">
                    <img src="/static/home/images/eyes.png" />
                    <span>{{item.viewCount}}</span>
                  </span>
                </div>
              </router-link>
            </div>

            <content-empty v-else-if="listLength == 0" :content="$t('global.没有相关的视频')"></content-empty>
            <div class="clearfix"></div>
            <pages
              :page-size="pagerParam.pageSize"
              :page-count="pagerParam.pageCount"
              :current-page="pagerParam.currentPage"
              :total="pagerParam.total"
              @current-page-changed="OnCurrentPageChanged"
            ></pages>
          </div>
        </div>

        <!--aboutactivity-->
        <div class="aboutactivity" v-if="activeIndex == 2">
          <div class="middle">
            <div class="unityvideo" v-if="listLength>0">
              <div v-for="item in list" :key="item.activityId">
                <router-link
                  :to="'/activity/'+item.activityId+'/detail'"
                  class="subjectpropusitem item_activity"
                >
                  <img class="subject-img" :src="item.activityThumb | imageUrl('',275,367)" />
                  <a>{{item.activityTitle}}</a>
                  <div v-if="item.status != 4">{{timeStamp(item.activityholdStartTime)}}</div>
                  <div v-if="item.status == 4">{{$t('global.已结束')}}</div>
                </router-link>
              </div>
            </div>

            <content-empty v-else-if="listLength == 0" :content="$t('global.没有相关的活动')"></content-empty>
            <div class="clearfix"></div>
            <pages
              :page-size="pagerParam.pageSize"
              :page-count="pagerParam.pageCount"
              :current-page="pagerParam.currentPage"
              :total="pagerParam.total"
              @current-page-changed="OnCurrentPageChanged"
            ></pages>
          </div>
        </div>

        <!--$t('global.成员')-->
        <SubjectMember1 v-if="activeIndex == 3" :index="childIndex"></SubjectMember1>
      </div>
    </div>
    <div v-show="isShowContent">
      <div class="fixwinlayout"></div>
      <div class="winpopus">
        <p>{{$t('global.频道公告')}}</p>
        <div>{{dialogContent.content}}</div>
        <div class="popusbtn" @click="isShowContent = false">
          <a>{{$t('global.取消')}}</a>
          <a @click="goUrl">{{$t('global.去看看')}}</a>
        </div>
        <img src="/static/home/images/closepopus.png" @click="isShowContent = false" />
      </div>
    </div>

    <!--发布弹窗-->
    <div v-if="publish" class="fixpublish"></div>
    <div v-if="publish" class="publishbtnbox">
      <p class="changepublish">{{$t('global.选择发布类型')}}</p>
      <div class="article" :class="{active:isActive == 0}" @click="changeActive(0)">
        <span>{{$t('global.文章')}}</span>
        {{$t('global.发表见解')}}，{{$t('global.分享知识')}}
      </div>
      <div class="question" :class="{active:isActive == 1}" @click="changeActive(1)">
        <span>{{$t('global.问答')}}</span>
        {{$t('global.精确描述问题')}}，{{$t('global.得到解答')}}
      </div>
      <a class="cancel" @click="closepopus">{{$t('global.取消')}}</a>
      <router-link
        :to="`/publishPage?topicId=${topicId}&typeId=${isActive}`"
        class="sure"
      >{{$t('global.确定')}}</router-link>
      <img @click="closepopus" src="/static/closepopus.png" />
    </div>

    <!--$t('global.登陆弹窗')-->
    <div v-if="logining" class="fixlogining"></div>
    <div v-if="logining" class="loginingbox">
      <p class="headlogo">
        <img src="/static/manalogo1.png" />
      </p>
      <div class="loginform">
        <input
          class="userinfor"
          type="text"
          :placeholder="`${$t('global.输入账号')}/${$t('global.邮箱')}`"
        />
        <input class="userinfor" type="password" :placeholder="$t('global.输入密码')" />
        <a class="loginbtn">{{$t('global.登录')}}</a>
        <router-link to="/reg" class="goregister">{{$t('global.没有账号')}}？{{$t('global.点击注册')}}</router-link>
        <div class="otherlogin">
          <span>{{$t('global.第三方登录')}}</span>
        </div>
        <div class="login-ways">
          <span class="login-way login-way-qq" @click="qqLogin"></span>
          <span class="login-way login-way-wechat" @click="wechatLogin"></span>
          <span class="login-way login-way-weibo" @click="weiboLogin"></span>
        </div>
        <img class="closepopus" @click="closepopus" src="/static/closepopus.png" />
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import pages from "../../components/pages.vue";
import ContentEmpty from "../../components/ContentEmpty";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import SubjectMember1 from "@/pages/subject/SubjectMember1.vue";
import discussArea from "../../pages/subject/discussArea.vue";
import SubjectDetailRight from "@/pages/subject/SubjectDetailRight.vue";
import "swiper/dist/css/swiper.css";
import Share from "vue-social-share";
import "vue-social-share/dist/client.css";
document.documentElement.style.overflowY = "scroll";

export default {
  name: "SubjectDetail",
  components: {
    SubjectDetailRight,
    MainLayout,
    pages,
    ContentEmpty,
    swiper,
    swiperSlide,
    SubjectMember1,
    discussArea,
    Share
  },
  data() {
    return {
      memberList: [],
      sortVideoSelected: {
        id: "1",
        icon: "/static/v2/match/sort_default.png",
        title: this.$t("global.默认排序")
      },
      sortList: [
        {
          id: "0",
          icon: "/static/v2/match/sort_default.png",
          title: this.$t("global.默认排序")
        },
        {
          id: "1",
          icon: "/static/v2/match/sort_latest.png",
          title: this.$t("global.最新排序")
        },
        {
          id: "2",
          icon: "/static/v2/match/sort_hot.png",
          title: this.$t("global.热门排序")
        }
      ],
      showVideoSort: false,
      isDishare: false,
      isWinsup: false,
      iscloseShare: false,
      istp140: false,
      //$t('global.删除多余')icon
      config: {
        disabled: [
          "douban",
          "qzone",
          "tencent",
          "google",
          "facebook",
          "twitter",
          "linkedin",
          "diandian"
        ]
      },

      filterSelected: 1,
      filterSearchContent: "",
      selectedOrder: 0,
      isChecking: true,
      isShowUpShow: false,
      checkall: true,
      isWinsup: false,
      isDishare: false,
      istp140: false,
      //隐藏显示 share
      isShowSchare: false,

      detail: {},
      list: [],
      //$t('global.热门活动')
      activitylist: [],
      //$t('global.视频')
      designvideolist: [],
      /*//$t('global.达人')
          philosopherman:[],
          //$t('global.相关频道')
          aboutCommunity:[],*/
      //$t('global.主持团')
      directitemList: [],

      listLength: -1,
      pagerParam: {
        pageSize: 12,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      bannerSlideList: [],
      swiperOptions: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 300,
        loop: true,
        effect: "fade",
        on: {
          slideChangeTransitionStart: function() {
            //that.imgIndex = this.realIndex + 1;
          }
        },
        pagination: {
          el: ".swiper-pagination",
          paginationClickable: true,
          clickable: true,
          type: "bullets"
        }
      },
      swiperOptionsNo: {},

      activeIndex: 0,
      childIndex: 0,
      topicId: -1,
      iscloseShare: false,
      isShowContent: false,
      dialogContent: {
        content: "",
        url: ""
      },
      /*$t('global.文本编辑器')*/
      editor: {},
      editorContent: "",

      publish: false,
      isActive: 0,
      logining: false,
      page: 0,
      isCreate: false
    };
  },
  created() {
    this.topicId = this.$query.id;
    this.GetDetail();
    this.GetData();
    this.getDesignVideoList();
    this.getTopBannerList();
    /*this.getPhilosopherMan();
        this.getAboutCommunity();*/
    this.getDirectitemList();
    this.getMemberList();
    this.page = this.$query.page;
  },
  methods: {
    showVideoSortList() {
      this.showVideoSort = true;
    },
    sortVideo() {
      this.sortVideoSelected = this.sortList[
        event.target.getAttribute("data-sort")
      ];
      this.showVideoSort = false;
    },
    shareCkeck() {
      this.istp140 = true;
      this.isDishare = true;
      this.isWinsup = true;
      if (!this.isShowSchare) {
        this.iscloseShare = false;
        document.getElementById("sharefrienf").style.display = "block";
      } else {
        this.iscloseShare = true;
        document.getElementById("sharefrienf").style.display = "none";
      }
      this.isShowSchare = !this.isShowSchare;
    },

    changeActive(index) {
      this.isActive = index;
    },
    //$t('global.登陆方式')
    weiboLogin() {
      this.$http.get("/api/passport/weiboLogin").then(res => {
        if (res) {
          location.href = res.data;
        }
      });
    },
    qqLogin() {
      this.$http.get("/api/passport/qqLogin").then(res => {
        if (res) {
          location.href = res.data;
        }
      });
    },
    wechatLogin() {
      this.$http.get("/api/passport/wechatLogin").then(res => {
        if (res) {
          location.href = res.data;
        }
      });
    },

    changeIndex(index, cIndex) {
      this.activeIndex = index;
      this.childIndex = cIndex;

      switch (index) {
        case 0:
          this.isCreate = false;
          break;
        case 1:
          this.isCreate = false;
          this.GetData();
          this.$router.push("subjectdetail?id=" + this.topicId + "&page=1");
          break;
        case 2:
          this.isCreate = false;
          this.GetData();
          this.$router.push("subjectdetail?id=" + this.topicId + "&page=2");
          break;
        case 3:
          this.isCreate = false;
          this.$router.push("subjectdetail?id=" + this.topicId + "&page=3");
          break;
        case 4:
          this.$router.push("subjectdetail?id=" + this.topicId + "&page=4");
          break;
      }
    },
    publishbtn() {
      let that = this;
      //未登陆弹登陆窗口
      if (!localStorage.getItem("auth_token")) {
        this.logining = true;
        document.documentElement.style.overflowY = "hidden";
      } else {
        //已登陆弹发布窗口
        this.publish = true;
        document.documentElement.style.overflowY = "hidden";
      }
    },
    closepopus() {
      this.publish = false;
      this.logining = false;
      document.documentElement.style.overflowY = "scroll";
    },

    closeShare() {
      this.iscloseShare = true;
    },
    goUrl() {
      window.open(this.dialogContent.url);
      this.isShowContent = false;
    },
    goBannerUrl(url) {
      if (url != "" && url != null) {
        window.open(url);
      }
    },
    //header banner
    getTopBannerList() {
      let $this = this;
      this.$http
        .get("/api/topic/banner/list?topicId=" + $this.$query.id)
        .then(function(response) {
          $this.bannerSlideList = response.data;
        });
    },
    //$t('global.达人')
    getPhilosopherMan() {
      let $this = this;
      this.$http
        .get(
          "/api/topic/getMemberListByParms?topicId=" +
            $this.$query.id +
            "&orderBy=0&roleIds=3&pageIndex=1&pageSize=3"
        )
        .then(function(response) {
          $this.philosopherman = response.data.list;
        });
    },
    //$t('global.热门活动')

    //$t('global.视频')
    getDesignVideoList() {
      let $this = this;
      this.$http
        .get(
          "/api/topic/videoList?topicId=" +
            $this.$query.id +
            "&status=2" +
            "&pageIndex=1&pageSize=12"
        )
        .then(function(response) {
          $this.designvideolist = response.data.list;
        });
    },
    //$t('global.相关频道')
    getAboutCommunity() {
      let $this = this;
      this.$http
        .get(
          "/api/topic/relevant/list?topicId=" +
            $this.$query.id +
            "&orderBy=0&pageIndex=1&pageSize=4"
        )
        .then(function(response) {
          $this.aboutCommunity = response.data.list;
        });
    },
    //$t('global.主持团')
    getDirectitemList() {
      let $this = this;
      this.$http
        .get(
          "/api/topic/getMemberListByParms?topicId=" +
            $this.$query.id +
            "&roleIds=1,2&pageIndex=1&pageSize=3"
        )
        .then(function(response) {
          $this.directitemList = response.data.list;
        });
    },

    getMemberList() {
      let url = "/api/2.0/topic/activityList";
      const params = {
        topicId: this.$query.id,
        roleIds: 0,
        orderBy: 1,
        pageIndex: 1,
        pageSize: 8
      };

      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.memberList = res.data.list.reverse();
          this.detail.memberCount = res.data.totalRecord;
        }
      });
    },

    introduc() {
      this.isChecking = false;
      this.checkall = false;
      this.isShowUpShow = true;
    },
    showupCk() {
      this.isChecking = true;
      this.checkall = true;
      this.isShowUpShow = false;
    },

    goToUser(userId) {
      this.$router.push(`/peopleCenter/${userId}`);
    },
    GetDetail() {
      var $this = this;
      $this.$http
        .get("/api/topic/detail?topicId=" + $this.$query.id)
        .then(function(response) {
          if (response.data) {
            $this.detail = response.data;
            $this.detail.introduction = $this.detail.introduction.replace(
              /\n/g,
              "<br>"
            );
            document.title = $this.detail.title + " | MANA";
          }
        });
    },
    showAllFun() {
      this.filterSelected = 1;
      this.filterSearchContent = "";
      this.GetData();
    },
    shareCkeck() {
      this.istp140 = true;
      this.isDishare = true;
      this.isWinsup = true;
      if (!this.isShowSchare) {
        this.iscloseShare = false;
        document.getElementById("sharefrienf").style.display = "block";
      } else {
        this.iscloseShare = true;
        document.getElementById("sharefrienf").style.display = "none";
      }
      this.isShowSchare = !this.isShowSchare;
    },
    imageUrl_(test) {
      if (test == null || test == "") {
        return this.$jsonUtils.imageUrl("");
      } else {
        return test;
      }
    },
    GetData() {
      var $this = this;
      let url_ = "";
      switch (this.activeIndex) {
        case 1:
          url_ =
            "/api/topic/videoList?topicId=" +
            $this.$query.id +
            "&keyword=" +
            $this.filterSearchContent +
            "&type=" +
            $this.filterSelected +
            "&status=2" +
            "&orderByType=" +
            $this.selectedOrder +
            "&pageIndex=" +
            $this.pagerParam.currentPage +
            "&pageSize=16";
          break;
        case 2:
          url_ =
            "/api/topic/activity/list?topicId=" +
            $this.$query.id +
            "&orderBy=0" +
            "&pageIndex=" +
            $this.pagerParam.currentPage +
            "&pageSize=16";
          break;
        default:
          return;
      }

      $this.$http.get(url_).then(function(response) {
        if (response.data) {
          $this.list = response.data.list;
          $this.pagerParam = {
            pageSize: response.data.pageSize,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
          $this.listLength = $this.list.length;
        }
      });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.GetData();
    },
    Follow(item) {
      let that = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push("/login");
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(function(response) {
          if (response) {
            item.isFollow = !item.isFollow;
            if (item.isFollow) {
              that.$message.success(response.message);
            } else {
              that.$message(response.message);
            }
          }
        });
    },
    Join() {
      var $this = this;
      if (this.detail.userType == 1) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
      } else if (this.detail.userType == 2) {
        this.$http
          .post("/api/u/topic/leave", {
            topicId: this.detail.id
          })
          .then(function(response) {
            $this.$message({
              message: $this.$t("global.离开成功"),
              type: "success",
              duration: 2000
            });
            $this.detail.userType = 3;
            $this.detail.memberCount = $this.detail.memberCount - 1;
          });
      } else if (this.detail.userType == 3) {
        this.$http
          .post("/api/u/topic/join", {
            topicId: this.detail.id
          })
          .then(function(response) {
            $this.$message({
              message: $this.$t("global.加入成功"),
              type: "success",
              duration: 2000
            });
            $this.detail.userType = 2;
            $this.detail.memberCount = $this.detail.memberCount + 1;
            $this.dialogContent.content = response.data.noticeContent;
            $this.dialogContent.url = response.data.noticeLink;
            $this.isShowContent = true;
          });
      } else if (this.detail.userType == 5 || this.detail.userType == 4) {
        this.$router.push(`/subject/edit/${this.topicId}/step1`);
      }
    }
  },
  watch: {
    selectedOrder: function() {
      this.GetData();
    },
    filterSelected: function() {
      this.GetData();
    },
    page(val) {
      if (val != null) {
        this.changeIndex(Number(val));
      }
    },
    $route: function(to, from) {
      if (
        to.fullPath.indexOf("subjectdetail") != -1 &&
        to.fullPath.indexOf("page") == -1
      ) {
        this.topicId = this.$query.id;
        this.GetDetail();
        this.GetData();
        this.getHostGroup();
        this.getDesignVideoList();
        this.getTopBannerList();
        this.getPhilosopherMan();
        this.getAboutCommunity();
        this.getDirectitemList();
      }
    },
    deep: true
  },
  computed: {
    state() {
      if (this.detail.userType == 4 || this.detail.userType == 5) {
        return this.$t("global.设置频道");
      } else {
        return this.detail.userType == 3 || this.detail.userType == 1
          ? `${this.$t("global.关注")}`
          : this.$t("global.已关注");
      }
    }
  },
  beforeCreate() {
    window._bd_share_main = "";
    setTimeout(() => {
      window._bd_share_config = {
        common: {
          bdSnsKey: {},
          bdText: "",
          bdMini: "2",
          bdMiniList: false,
          bdPic: "",
          bdStyle: "1",
          bdSize: "16"
        },
        share: {}
      };
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "/static/share/baidushare.js";
      document.body.appendChild(s);
    }, 0);
  }
};
</script>

<style lang="stylus" scoped>
.absolutetopbox {
  position: relative;
  width: 100%;
  height: 330px;
  overflow: hidden;
}

.bannercenter {
  position: relative;
  /* -webkit-filter:blur(30px); */
  /* -moz-filter:blur(30px); */
  /* -ms-filter:blur(30px); */
  /* -o-filter:blur(30px); */
  /* filter:blur(30px); */
}

.fixedsbox {
  position: relative;
  width: 100%;
  height: 330px;
  z-index: 0;
  top: -330px;
  left: 0;
  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -ms-filter: blur(10px);
  -o-filter: blur(10px);
  filter: blur(10px);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
  background-position: center center;
  background-size: 100%;
}

.absolutetopbox .banner {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  height: 330px;
}

.absolutetopbox .banner .swiper-slide {
  width: 100% !important;
  height: 330px;
}

.absolutetopbox .banner .wrapperswiper {
  width: 100%;
  height: 330px;
}

.absolutetopbox .banner .swiper-slide .centerbg {
  position: absolute;
  width: 1160px;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  border: 1px solid red;
}

.absolutetopbox .banner .swiper-slide .centerbg img {
  width: 100%;
  height: 100%;
}

.contentstart {
  overflow: hidden;
  background-color: #fff;
}

.touchdesigner {
  width: 1160px;
  margin: 0 auto;
  height: auto;
  display: flex;
  flex-direction: row;
}

.touchdesigner .touchleft {
  position: relative;
  float: left;
  width: 730px;
  height: auto;
}

.touchdesigner .touchleft .top > img {
  position: absolute;
  left: 0;
  top: -50px;
  width: 150px;
  height: 150px;
  z-index: 99;
  border: 2px solid #fff;
  box-sizing: border-box;
}

.touchdesigner .designlabel {
  position: relative;
  margin-left: 170px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;

  .directitemList {
    width: 100%;
    padding-bottom: 12px;

    b {
      color: #999;
      width: auto;
      font-size: 14px;
    }

    span {
      font-size: 14px;
      color: #0A0A0A;
      margin: 0;
      line-height: 20px;
      height: auto;
    }
  }
}

.designlabel b {
  width: 100%;
  float: left;
  color: #000;
  font-size: 24px;
  font-weight: bold;
}

.designlabel p span {
  display: inline-block;
  float: left;
  // width: 78px;
  height: 25px;
  color: #2026CC;
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  margin: 6px 0 6px 10px;
  cursor: pointer;
  // background: rgba(237, 241, 240, 1);
  border-radius: 2px;
}

.designlabel p span:nth-child(2) {
  margin-left: 0;
}

.designlabel p > *:nth-child(n + 5) {
  display: none !important;
}

.descreption {
  position: relative;
  clear: both;
  font-size: 14px;
  transition: all 3s ease;

  p {
    color: #666;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;

    &.checking {
      height: 48px;
      overflow: hidden;

      &:after {
        content: '...';
        width: 120px;
        text-align: center;
        position: absolute;
        bottom: 0;
        right: 0;
        background: linear-gradient(to right, transparent, #fff 40%);
      }
    }
  }

  .showdown {
    color: #2026CC;
    position: absolute;
    cursor: pointer;
    right: 5px;
    bottom: 3px;
  }

  .showup {
    color: #2026CC;
    text-align: left;
    cursor: pointer;
    margin-top: 10px;
  }
}

.transion {
  height: auto;
}

.touchright {
  width: 250px;
  text-align: right;
  margin-left: 90px;
  padding-top: 14px;
}

.touchright .sharetofriend {
  position: absolute;
  width: 136px;
  left: 103px;
  top: 60px;
  height: 150px;
  padding: 10px 10px;
  border-radius: 4px;
  z-index: 10;
  background-color: #fff;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  transition: all 0.5s ease;
  box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
}

.touchright #sharefrienf {
  display: none;
}

.sharetofriend a {
  position: relative;
  display: block;
  margin: 0;
  text-align: center;
  font-size: 14px;
  color: #8590a6;
  height: 40px;
  width: 114px;
  padding: 0;
  z-index: 1;
  line-height: 40px;
  cursor: pointer;
  box-sizing: border-box;
}

.bdshare-button-style1-16 .bds_tsina {
  background-position: 0 -92px;
}

.bdshare-button-style1-16 .bds_weixin {
  background-position: 0 -1602px;
}

.bdshare-button-style1-16 .bds_sqq {
  background-position: 1px -2641px;
}

.bdsharebuttonbox p {
  position: absolute;
  display: none;
  width: 125px;
  left: 0;
  z-index: 0;
  height: 40px;
  background-color: #ececec;
}

.bdsharebuttonbox .bds_tsina + p {
  top: 10px;
}

.bdsharebuttonbox .bds_weixin + p {
  top: 50px;
}

.bdsharebuttonbox .bds_sqq + p {
  top: 90px;
}

.sharetofriend p a {
  color: #8590a6;
  margin-top: 12px !important;
}

.sharetofriend a:hover {
  background-color: #ececec;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.sharetofriend .bdsharebuttonbox a:hover + p {
  display: block;
}

.sharetofriend .arrowfix {
  position: absolute;
  display: inline-blick;
  width: 15px;
  height: 15px;
  top: -10px;
  left: 62px;
  transform: rotate(45deg);
  border: 1px solid #ebebeb;
  border-right: none;
  border-bottom: none;
  background-color: #fff;
}

.touchright p {
  clear: both;
  font-size: 12px;
  color: #999;
  padding-right: 10px;
}

.touchright p span {
  margin-left: 15px;
}

.touchright p b {
  font-size: 16px;
  color: #000;
  margin-left: 5px;
}

.touchright .shareds {
  float: right;
  width: 90px;
  height: 30px;
  border-radius: 2px;
  color: #2026CC;
  font-size: 14px;
  margin: 0 0 24px 0;
  border: 1px solid #2026CC;
  box-sizing: border-box;
  background-color: #fff;
}

.touchright .shareds img {
  width: 12px;
  height: 12px;
  vertical-align: middle;
}

.touchright .addsheq {
  float: right;
  width: 90px;
  height: 30px;
  color: #fff;
  margin-right: 15px;
  background: #2026CC;
  border-radius: 2px;
  font-size: 14px;

  &::before {
    content: '+ ';
  }

  &.followed {
    background: #B8B8B8;

    &::before {
      content: '';
      background: url('/static/v2/match/channel_follow_btn_ticked.png');
      display: inline-block;
      // margin-right: 5px;
      height: 12px;
      width: 12px;
      background-size: 12px;
      top: 1px;
      position: relative;
    }
  }
}

.videobox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  div {
    line-height: 33px;
    text-align: center;
    position: relative;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    span {
      cursor: pointer;

      img {
        width: 18px;
        height: 18px;
        vertical-align: sub;
      }
    }

    ul {
      width: 125px;
      box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
      border: 1px solid rgba(235, 235, 235, 1);
      position: absolute;
      top: 33px;
      left: -26px;
      z-index: 1;
      background: #fff;
      padding: 10px 0;

      li {
        line-height: 34px;
        cursor: pointer;

        &:hover {
          background: #F5F5F5;
        }

        img {
          width: 18px;
          height: 18px;
          vertical-align: sub;
        }
      }
    }
  }
}

.videstart {
  margin: 20px 0;
  overflow: hidden;
}

.videstart ul {
  overflow: hidden;
}

.videstart .videotime {
  position: absolute;
  top: 110px;
  right: 10px;
  padding: 3px 6px;
  color: rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
}

/* designercontet start */
.designercontet {
  width: 1160px;
  height: auto;
  margin: 46px auto 0;
  clear: both;
}

.navhead {
  height: 30px;
  border-bottom: 1px solid rgba(237, 236, 241, 1);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ul {
    width: 760px;
  }

  .member {
    width: 300px;
    text-align: right;

    p {
      font-size: 12px;
      color: #0A0A0A;
      font-weight: 200;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      padding-right: 30px;

      span {
        vertical-align: middle;
        position: relative;
        width: 20px;
        display: inline-block;

        &:first-child {
          margin-right: 10px;
        }

        img {
          width: 24px;
          height: 24px;
          border-radius: 12px;
          border: 1px solid #fff;
        }
      }
    }
  }
}

.designercontet .navhead li {
  float: left;
  font-size: 16px;
  color: #999;
  fong-weight: 400;
  height: 30px;
  line-height: 30px;
  margin-right: 60px;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.designercontet .navhead li.active {
  color: #333;
  border-bottom: 2px solid #333;
  font-weight: bold;
}

.contentleft {
  float: left;
  width: 730px;
  margin-top: 40px;

  .communActivity {
    strong {
      font-size: 24px;
      height: 33px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0A0A0A;
    }
  }
}

.hostactivity {
  margin-top: 20px;
  overflow: hidden;
}

.hostactivity li, .videstart li {
  float: left;
  width: 350px;
  margin: 0 30px 30px 0;
  overflow: hidden;
}

.videstart li {
  height: 280px;
  position: relative;
}

.hostactivity li:nth-child(2n), .videstart li:nth-child(2n) {
  margin-right: 0;
}

.hostactivity li .hostac {
  width: 100%;
  height: 320px;
  -webkit-border-radius: 4px;
  -moz-border-radius: px;
  border-radius: 4px;
}

.videstart li .videothump {
  width: 100%;
  height: 197px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.hostactivity li p, .videstart li p {
  margin: 8px 0 5px 0;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  height: 44px;
  overflow: hidden;
  line-height: 22px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.hostactivity li span {
  font-size: 12px;
  color: #999;
}

.userheadinfor {
  font-size: 12px;
  color: #999;
}

.userheadinfor .userleft {
  float: left;
}

.userheadinfor .userleft img {
  width: 26px;
  height: 26px;
  border-radius: 100%;
}

.userheadinfor .userleft span {
  position: relative;
  top: 2px;
}

.userheadinfor .userright {
  float: right;
  margin-top: 7px;
}

.userheadinfor .userright img {
  position: relative;
  width: 20px;
  height: 12px;
  top: -1px;
}

/* check video */
.checkvideomodel {
  margin-top: 50px;
}

.orderby {
  color: #858585;
  font-size: 12px;
  height: 30px;
}

.orderby strong {
  font-size: 16px;
  float: right;
  color: #333;
}

.orderby .active {
  color: #0060ff;
}

.orderby label {
  cursor: pointer;
}

.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.15rem;
  background: url('/static/explore/time.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.14rem;
  background: url('/static/explore/visit.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.15rem;
  background: url('/static/explore/zan.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('/static/explore/comment.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby .active-time {
  background: url('/static/explore/focusTime.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-visit {
  background: url('/static/explore/focusVisit.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-zan {
  background: url('/static/explore/focusZan.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-comment {
  background: url('/static/explore/focusComment.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-comment[data-v-57d14473] {
  background: url('/static/explore/focusComment.png') no-repeat 50%;
  background-size: contain;
}

.unityvideo > div {
  float: left;
  width: calc(((100% - 60px) / 4));
  margin: 0 20px 24px 0;
}

.unityvideo > div:nth-child(4n) {
  margin-right: 0;
}

.subjectpropusitem img {
  width: 100%;
  height: 155px;
  border-radius: 5px;
}

.item_activity img {
  height: 367px;
}

.unityvideo a a, .saytitle {
  display: block;
  position: relative;
  width: 275px;
  height: 40px;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin: 10px 0 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.subjectpropusitem > a:first-child {
  height: 155px;
}

.subjectpropusitem .videotime {
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 3px 6px;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
}

.subjectpropusitem div {
  color: #999;
}

.unityvideo + a + div {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
}

.userlistpic img {
  width: 26px;
  height: 26px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  margin-right: 10px;
}

.userlistpic + a {
  position: relative;
  display: inline-block;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  top: 4px;
  vertical-align: middle;
}

.openeye {
  float: right;
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.openeye img {
  position: relative;
  top: -1px;
  width: 20px;
  height: 12px;
  vertical-align: middle;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.animated.hinge {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

.animated.flipOutX, .animated.flipOutY, .animated.bounceIn, .animated.bounceOut {
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
}

.touchright .closeshare {
  display: none !important;
}

.dataNone, .dataNone + .philosoman, .zitemNone, .zitemNone + .directitem, .aboutdata, .aboutdata + .aboutCommunity, .hotdata, .hotdata + .hostactivity {
  display: none !important;
}

.fixwinlayout {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.7;
  z-index: 9999;
  background-color: #000;
}

.winpopus {
  position: fixed;
  width: 600px;
  height: 153px;
  top: 50%;
  left: 50%;
  z-index: 10000;
  color: #333;
  font-size: 14px;
  padding: 10px;
  border-radius: 5px;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 5px #fff;
}

.winpopus p {
  margin-bottom: 30px;
}

.winpopus .popusbtn {
  float: right;
  width: 134px;
  height: 40px;
  margin-top: 40px;
}

.winpopus .popusbtn a {
  display: inline-block;
  width: 60px;
  height: 30px;
  color: #ccc;
  line-height: 30px;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  border: 1px solid #ccc;
}

.winpopus .popusbtn a:last-child {
  color: #fff;
  margin-left: 5px;
  border: 1px solid rgba(68, 123, 249, 1);
  background: rgba(68, 123, 249, 1);
}

.winpopus img {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

@keyframes bounceInUp {
  from, 60%, 75%, 90%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100px, 0);
    transform: translate3d(0, 100px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -2px, 0);
    transform: translate3d(0, -2px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes bounceInUp {
  from, 60%, 75%, 90%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100px, 0);
    transform: translate3d(0, 100px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -2px, 0);
    transform: translate3d(0, -2px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
}

.aboutactivity .middle {
  margin-top: 20px;
}

.thumba {
  height: 330px;
  text-align: center;
}

.thumba .bg {
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100%;
  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -ms-filter: blur(10px);
  -o-filter: blur(10px);
  filter: blur(10px);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
}

.thumba img {
  width: 1160px;
  height: 330px;
  margin: 0 auto;
}

.swiper-pagination {
  width: 100%;
  position: absolute;
  text-align: center;
  -webkit-transition: 300ms opacity;
  -o-transition: 300ms opacity;
  transition: 300ms opacity;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  z-index: 1000;
  bottom: 26px !important;
}

.wrapperswiper .swiper-pagination .swiper-pagination-bullet {
  margin: 0 0.1rem;
  opacity: 1;
  width: 0.16rem;
  height: 0.16rem;
  background-color: transparent;
  box-sizing: border-box;
  border: 2px solid #fff;
}

.wrapperswiper {
  .swiper-pagination, .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #fff;
  }

  .signatureuser {
    height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .deliberate .titles {
    width: 320px;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .deliberate .userinfor {
    height: 26px;
    margin-top: 12px;
    color: #999;
    font-size: 12px;
  }

  .deliberate .userinfor img {
    float: left;
    width: 26px;
    height: 26px;
    border-radius: 13px;
  }

  .deliberate .userinfor img + span {
    float: left;
    display: inline-block;
    width: 150px;
    margin: 6px 0 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .deliberate .userinfor .peopleNums {
    float: left;
    width: 80px;
    margin: 4px 5px 0;
    font-size: 12px;
    height: 14px;
    text-align: center;
    overflow: hidden;
  }

  .deliberate .userinfor .peopleNums + a {
    float: right;
    margin-top: 6px;
  }

  .deliberate ul li {
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(237, 236, 241, 1);
  }

  .deliberate ul li:last-child {
    margin-bottom: 20px;
  }

  .deliberate ul li:first-child ~ li {
    padding-top: 15px;
  }

  .advertising {
    position: relative;
    width: 100%;
    height: 107px;
    margin-bottom: 20px;
  }

  .advertising .adintro {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

  .advertising span {
    position: absolute;
    display: inline-block;
    bottom: 10px;
    right: 10px;
    width: 64px;
    text-align: center;
    height: 30px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    line-height: 30px;
    border-radius: 2px;
    background-color: rgba(35, 116, 255, 1);
  }

  /* 发布弹窗 $t('global.登陆') */
  .fixpublish, .fixlogining {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.5);
  }

  .publishbtnbox, .loginingbox {
    position: fixed;
    width: 428px;
    height: 356px;
    top: 50%;
    left: 50%;
    z-index: 100;
    transform: translate(-50%, -50%);
    background-color: #fff;
  }

  .changepublish {
    color: #333;
    font-size: 20px;
    width: 428px;
    text-align: center;
    margin-top: 30px;
  }

  .publishbtnbox .article {
    width: 358px;
    height: 63px;
    color: #999;
    font-size: 14px;
    line-height: 63px;
    border-radius: 5px;
    margin: 29px auto 0;
    cursor: pointer;
    border: 1px solid rgba(221, 221, 221, 1);
  }

  .publishbtnbox .article span {
    font-size: 24px;
    font-weight: bold;
    margin: 0 20px;
  }

  .publishbtnbox .question {
    width: 358px;
    height: 63px;
    color: #999;
    font-size: 14px;
    line-height: 63px;
    border-radius: 5px;
    margin: 20px auto 0;
    cursor: pointer;
    border: 1px solid rgba(221, 221, 221, 1);
  }

  .publishbtnbox .question span {
    font-size: 24px;
    font-weight: bold;
    margin: 0 20px;
  }

  .publishbtnbox div.active {
    color: #43c0bd;
    border: 1px solid rgba(67, 192, 189, 1);
  }

  .publishbtnbox a {
    display: inline-block;
    float: left;
    width: 100px;
    height: 40px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 44px;
    background-color: #4a90e2;
  }

  .publishbtnbox a.cancel {
    margin: 44px 20px 0 104px;
    background: rgba(202, 202, 202, 1);
  }

  .publishbtnbox img, .loginingbox img.closepopus {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  /* loginingbox  start */
  .loginingbox {
    height: 504px;
  }

  .loginingbox .headlogo {
    width: 130px;
    height: 34px;
    margin: 55px auto 0;
  }

  .loginingbox .headlogo img {
    width: 100%;
    height: 100%;
  }

  .loginingbox .loginform {
    padding: 50px 64px 0;
  }

  .loginingbox .loginform input.userinfor {
    width: 100%;
    height: 40px;
    font-size: 16px;
    margin-bottom: 30px;
    border-bottom: 1px solid #e8e8e8;
  }

  .loginingbox .loginbtn {
    display: block;
    width: 100%;
    height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    line-height: 40px;
    background-color: #abaaba;
  }

  .loginingbox .goregister {
    display: block;
    color: #999;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    margin-top: 22px;
  }

  .loginingbox .otherlogin {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin-top: 30px;
  }

  .loginingbox .otherlogin span {
    display: inline-block;
    position: relative;
    width: 100px;
  }

  .loginingbox .otherlogin span:after {
    position: absolute;
    display: block;
    content: '';
    height: 1px;
    width: 120px;
    top: 8px;
    left: 130px;
    background-color: #e8e8e8;
  }

  .loginingbox .otherlogin span:before {
    position: absolute;
    display: block;
    content: '';
    height: 1px;
    width: 120px;
    top: 8px;
    right: 130px;
    background-color: #e8e8e8;
  }

  /* login-way */
  .login-ways {
    text-align: center;
    margin-top: 30px;
  }

  .login-ways span {
    cursor: pointer;
  }

  .login-way {
    display: inline-block;
    width: 0.36rem;
    height: 0.36rem;
    margin: 0 0.275rem;
  }

  .login-way-qq {
    background: url('/static/qq.png') no-repeat center center;
    background-size: contain;
  }

  .login-way-wechat {
    background: url('/static/wechat.png') no-repeat center center;
    background-size: contain;
  }

  .login-way-weibo {
    background: url('/static/weibo.png') no-repeat center center;
    background-size: contain;
  }

  .loginform input::-webkit-input-placeholder {
    color: #999;
    font-size: 16px;
  }

  .loginform input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #999;
    font-size: 16px;
  }

  .loginform input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #999;
    font-size: 16px;
  }

  .loginform input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #999;
    font-size: 16px;
  }

  .communActivity span {
    display: inline-block;
    float: right;
    width: 33.35px;
    color: #999;
    font-size: 12px;
    cursor: pointer;
    line-height: 16px;
    margin-top: 5px;
  }

  .communActivity span img {
    float: right;
    margin-top: 4px;
  }

  .parentShare {
    position: relative;
  }

  .icon-douban, .icon-qzone {
    display: none !important;
  }

  .social-share {
    position: absolute;
    width: 146px;
    top: -27px;
    left: 50px;
    height: 64px;
    z-index: 9999;
    border-radius: 4px;
    margin-left: 56px;
    padding: 10px 5px 10px 10px;
    box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
    background-color: #fff;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
  }

  .social-share:after {
    position: absolute;
    display: block;
    content: '';
    top: -6px;
    left: 67px;
    width: 10px;
    height: 10px;
    border: 1px solid #ebebeb;
    border-radius: 2px;
    border-right: none;
    border-bottom: none;
    transform: rotate(45deg);
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/SubjectDetail.vue